﻿import dimbox from 'dimbox';
import { createApp } from 'vue/dist/vue.esm-bundler';
import wishlistApp from './../vue/favouritesList';

document.addEventListener('DOMContentLoaded', () => {
    dimbox.setConfig({
        showDownloadButton: false,
        iframeTemplate: '<div class="dimbox-iframe-container" ><iframe src="{{src}}" class="dimbox-iframe" allow="autoplay; encrypted-media" allowfullscreens></iframe><div class="dimbox-caption">{{caption}}</div></div>',
        onAfterOpen: () => {
            let wishlistContainer = document.querySelector('.dimbox-inline-content .wishlist-list');
            if (wishlistContainer) {
                createApp(wishlistApp).mount(wishlistContainer);
            }
        }
    });
});